import React from "react";

const QUICK_EMOJIS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

export default function MessageReactionBar({
  onSelectEmoji,
  onOpenMore,
  className = "",
  style = {},
}) {
  return (
    <div
      className={`wa-reaction-bar ${className}`}
      style={style}
      role="toolbar"
      aria-label="Reactions"
      onClick={(e) => e.stopPropagation()}
    >
      {QUICK_EMOJIS.map((emoji) => (
        <button
          key={emoji}
          type="button"
          className="wa-reaction-btn"
          onClick={(e) => {
            e.stopPropagation();
            onSelectEmoji(emoji);
          }}
          title={`React with ${emoji}`}
        >
          <span className="wa-reaction-glyph">{emoji}</span>
        </button>
      ))}

      <button
        type="button"
        className="wa-reaction-btn wa-reaction-more-btn"
        onClick={(e) => {
          e.stopPropagation();
          if (onOpenMore) onOpenMore();
        }}
        title="More reactions"
      >
        <i className="bi bi-plus-lg"></i>
      </button>
    </div>
  );
}
